import { PropTypes } from 'prop-types';
import React from 'react';
import Filter from './filter';
import Config from '../config';

const FilterBar = ({
    filterOptions,
    filter,
    isLoading,
    onInputChange,
    clearFilter,
    onClickFilterOption,
    searchPlaceholder = Config.searchPlaceholder
}) => {
    const filters = filterOptions.map(fo => (
        <Filter
            {...fo}
            key={fo.name}
            activeOptions={filter[fo.name] ? filter[fo.name] : []}
            onClickOption={onClickFilterOption}
        />
    ));

    let classList = ['filter-bar'];
    if (isLoading) {
        classList.push('loading');
    }

    return (
        <div className="filter-bar-outer-container">
            <div className={classList.join(' ')}>
                <div className="filter-bar-wrapper container">
                    <div className="filter-bar-header">
                        <h2 className="filter-bar-heading">
                            <span className="filter-bar-heading-icon"><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.5 14.6"><path d="M0 12.2h13.1v2.4H0zm0-6.1h16.3v2.4H0zM0 0h19.5v2.4H0z" fill="#413F43" /></svg></span>
                        </h2>
                        <button className="filter-toggle" role="button" aria-label="Toggle display of results filters" aria-expanded="false" aria-controls="vrc-filters">
                            <span className="filter-bar-heading-icon"><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.5 14.6"><path d="M0 12.2h13.1v2.4H0zm0-6.1h16.3v2.4H0zM0 0h19.5v2.4H0z" fill="#413F43" /></svg></span>
                        </button>
                    </div>
                    <div id="vrc-filters" className="filters" aria-hidden="true">
                        <div className="filters-wrapper">{filters}</div>
                        <div className="filters-footer">
                            <button className="filters-close" role="button" aria-label="Show filtered results" aria-expanded="false" aria-controls="vrc-filters">Show Results</button>
                        </div>
                    </div>
                    <div className="filter-bar-search">
                        <input
                            className="filter-bar-search-input"
                            type="search"
                            placeholder={searchPlaceholder}
                            onChange={onInputChange}
                            spellCheck="false"
                        />
                        <button className="search-submit" role="button">
                            <svg aria-hidden="true" className="search-submit-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M24.8 39.2c3.4 3.4 7.4 5.1 12.2 5.1s8.8-1.7 12.2-5.1 5.1-7.4 5.1-12.2-1.7-8.8-5.1-12.2S41.8 9.7 37 9.7s-8.8 1.7-12.2 5.1-5.1 7.4-5.1 12.2 1.7 8.9 5.1 12.2zM1.4 55.6l13.2-13.2c-3.2-4.6-4.8-9.7-4.8-15.3 0-3.7.7-7.2 2.1-10.5s3.3-6.2 5.8-8.7 5.3-4.3 8.7-5.8S33.3 0 36.9 0c3.7 0 7.2.7 10.5 2.1s6.2 3.3 8.7 5.8 4.3 5.3 5.8 8.7S64 23.4 64 27.1s-.7 7.2-2.1 10.5-3.3 6.2-5.8 8.7-5.3 4.3-8.7 5.8-6.9 2.1-10.5 2.1c-5.6 0-10.8-1.6-15.3-4.8L8.4 62.5c-.9 1-2.1 1.5-3.5 1.5-1.3 0-2.5-.5-3.5-1.5S-.1 60.4-.1 59c.1-1.3.6-2.4 1.5-3.4z" /></svg>
                            <span className="screen-reader-text">Search</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

FilterBar.propTypes = {
    filterOptions: PropTypes.array,
    filter: PropTypes.object,
    isLoading: PropTypes.bool,
    onInputChange: PropTypes.func,
    clearFilter: PropTypes.func,
    onClickFilterOption: PropTypes.func,
    searchPlaceholder: PropTypes.string
};

export default FilterBar;



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/components/filter-bar.js